import { useParams } from "../../../../router-utils"
import { Outlet } from "react-router"
import { TripSourceDetailsContainer } from "../../../../TripSources"

export default function TripSourceDetailsLayout() {
	const { tripSourceId } = useParams("/trip-sources/:tripSourceId")
	return (
		<TripSourceDetailsContainer tripSourceId={tripSourceId}>
			{({ tripSource, revalidate }) => (
				<Outlet
					context={{
						tripSource,
						revalidate,
					}}
				/>
			)}
		</TripSourceDetailsContainer>
	)
}
